/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Recording_Device_NoteInputs */



/**
* | output |
* | --- |
* | "Switching microphone is only possible after the recording." |
*
* @param {Meeting_Offline_Recording_Device_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_recording_device_note = /** @type {((inputs?: Meeting_Offline_Recording_Device_NoteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Recording_Device_NoteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Van micro wisselen kan pas na de opname.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Changer de micro n'est possible qu'après l'enregistrement.")
	return /** @type {LocalizedString} */ ("Switching microphone is only possible after the recording.")
});